import React, { PureComponent, Fragment } from 'react';

import { shuffle } from '~/core/scripts/utils';
import * as Config from '../QuizConfig';
import Sticky from '../Sticky';
import QuizItem from './QuizItem';
import Result from './Result';
import Headline from '../Headline';

class Quiz extends PureComponent {
  state = {
    questions: []
  }

  constructor() {
    super();

    this.quizConfig = Config[ARTICLE_CONFIG.quizId] || Config['morgenpost'];
    this.quizConfig.questions = this.quizConfig.questions.map((q, index) => ({ __id: index, ...q }));
    const questions = shuffle(this.quizConfig.questions).map(q => ({ ...q, answers: shuffle(q.answers) }));

    this.state = {
      questions
    };
  }

  handleAnswer(place, correct) {
    this.setState(prevState => {
      const questions = prevState.questions.map(q => ({
        ...q,
        finished: place.id === q.id ? true : q.finished,
        correct: place.id === q.id ? correct : q.correct
      }));

      return {
        questions
      };
    });
  }


  render() {
    const { title, introtext, resultSentences } = this.quizConfig;
    const { questions } = this.state;

    return (
      <Fragment>
        <Headline title={title} introtext={introtext} />
        <div className="quiz-wrapper layout-large">
          {questions.map((place, index) => (
            <QuizItem
              key={place.id}
              index={index + 1}
              onAnswer={(isCorrect) => this.handleAnswer(place, isCorrect)}
              {...place}
            />
          ))}
        </div>
        <Sticky sides={{ bottom: 0 }} innerZ={10000}>
          <Result
            questions={questions}
            sentences={resultSentences}
          />
        </Sticky>
      </Fragment>
    );
  }
}

export default Quiz;
